import LanguageDetector from "i18next-browser-languagedetector";

export { LanguageDetector };
